// extracted by mini-css-extract-plugin
export var orderDetails = "_qa-2";
export var orderImage = "_qa-1";
export var orderMeta = "_qa-3";
export var orderSummary = "_qa-0";
export var rightArrow = "_qa-4";